<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<nav aria-label="Main navigation">
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center justify-center h-20 p-6 pb-0">
        <!-- Light version -->
        <img
          class="dark:hidden w-10"
          src="assets/images/logo/eprint-logo.svg"
          alt="Logo image">
          <!-- Dark version -->
          <img
            class="hidden dark:flex w-10"
            src="assets/images/logo/eprint-logo.svg"
            alt="Logo image">
          </div>
        </ng-container>
      </fuse-vertical-navigation>
    </nav>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full min-w-0 max-h-[100%] overflow-auto" id="container">

      <!-- Header -->
      <header aria-label="Page header" class="relative flex flex-0 items-center w-full h-12 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
          mat-icon-button id="classicCmp_toggleNavBtn"
          aria-label="Toggle navigation menu"
          (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <!-- <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
        <app-languages></app-languages>
        <user></user>
      </div> -->
      <app-breadcrumb [breadCrumbConfig]="breadCrumbConfig"></app-breadcrumb>

    </header>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>

    <!-- Footer -->
    <footer aria-label="Page footer" class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
      <span class="font-medium text-secondary">ePRINTit &copy; {{currentYear}}</span>
    </footer>

  </div>
